import * as React from 'react';
import * as moment from 'moment';

interface Props {
  dateAdd: Date;
  author: string;
  comment: string;
}

const Comment = (props: Props) => {
  return(
    <div>
      <div className='d-flex flex-column comment'>
        <div className='d-flex justify-around align-center comment-wrapper'>
          <div className='d-flex'>
            <div className='comment-sub'>{'Author:'}</div>
            <div className='comment-sub-text'>{props.author}</div>
          </div>
          <div className='d-flex'>
            <div className='comment-date'>{moment(props.dateAdd).format('YYYY/MM/DD')}</div>
          </div>
        </div>
        <p className='comment-text'>
          {props.comment}
        </p>
      </div>
      <div className='profile-hr' />
    </div>
  );
};

export default Comment;
